import {StickyHeader, YStack} from "@chayka/ui";
import {DrawerMenu, SignInOrSignUp, CommonArea} from "@/components";
import {NewsPreview} from "./ui/NewsPreview";

export const MainPageUnauthorized = () => {
  return (
    <>
      <StickyHeader />
      <DrawerMenu />
      <NewsPreview />
      <YStack className="justify-center items-stretch">
        <SignInOrSignUp />
      </YStack>
      <CommonArea />
    </>
  );
};
